import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'emptyToDash' })
export class EmptyToDashPipe implements PipeTransform {
  transform(value: any): any {
    if (value === null || value === undefined || value === '' || value.toString().trim() === '') {
      return '-';
    }
    return value;
  }
}
